import Tab from './lib/Tab';

const accordionInit = () => {
  const tabs: NodeListOf<HTMLElement> = document.querySelectorAll('.tab');

  tabs?.forEach((tab) => new Tab(tab));
};

export default accordionInit;
